module.exports = __webpack_public_path__ + "static/julia-wilkin-50fd306e1c533ae33d1ea46de5c8fbb7.jpg";